import styled from 'styled-components';

export const StyledSlider = styled.div`
  width: 100%;
  max-width: 660px;
  min-height: 340px;
  input {
    display: none;
  }

  @media (max-width: 1003px) {
    min-height: 385px;
    display: flex;
    flex-direction: row-reverse;
  }
`;

export const Styledtestimonials = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 300px;
  perspective: 500px;
  overflow: hidden;

  @media (max-width: 1003px) {
    width: 100%;
  }
`;

export const StyledItem = styled.label`
  /* top: 0; */
  position: absolute;
  background-color: transparent;
  width: 397px;
  transition: transform 0.2s;
  transform-style: preserve-3d;
  user-select: none;
  cursor: pointer;

  @media (max-width: 1275px) {
    width: 306px;
  }

  @media (max-width: 1003px) {
    top: auto;
    width: 283px;
  }
`;

export const StyledMyCard = styled.div`
  height: 100%;
  width: 100%;
  max-width: 24rem;
`;

export const StyledCardTitle = styled.p`
  font-weight: bold;
  --tw-text-opacity: 1;
  color: rgba(31, 41, 55, var(--tw-text-opacity));
  text-align: center;
`;

export const StyledCardImg = styled.img`
  margin-left: auto;
  margin-right: auto;
  margin-top: 2.75rem;
  margin-bottom: 2.75rem;
  max-height: 6rem;
  border-radius: 9999px;
  width: 100px;
  border-radius: 50%;
  border: 13px solid #3b344d;
`;

export const StyledCardDescription = styled.p`
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
  text-align: center;
`;

export const StyledDots = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  label {
    display: block;
    height: 5px;
    width: 5px;
    border-radius: 50%;
    cursor: pointer;
    background-color: #413b52;
    margin: 7px;
    transition: transform 0.2s, color 0.2s;
  }

  @media (max-width: 1003px) {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledRadioInput2 = styled.input`
  &:checked ~ .dots label[for='t-2'] {
    transform: scale(2);
  }
  &:checked ~ .dots label[for='t-3'] {
    transform: scale(1.5);
    background-color: #d9d9d9;
  }
  &:checked ~ .dots label[for='t-4'] {
    transform: scale(1.5);
    background-color: #d9d9d9;
  }
  &:checked ~ .testimonials label[for='t-2'] {
    z-index: 3;
  }
  &:checked ~ .testimonials label[for='t-3'] {
    transform: translateX(175px) translateZ(-35px) translateY(15px);
    z-index: 2;
    @media (max-width: 1400px) {
      transform: translateX(120px) translateZ(-35px) translateY(8px);
    }
    @media (max-width: 1270px) {
      transform: translateX(120px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1145px) {
      transform: translateX(100px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1003px) {
      transform: translateX(0px) translateZ(-50px) translateY(90px);
    }
  }
  &:checked ~ .testimonials label[for='t-4'] {
    transform: translateX(-127px) translateZ(-35px) translateY(15px);
    z-index: 1;
    @media (max-width: 1400px) {
      transform: translateX(-92px) translateZ(-35px) translateY(8px);
    }
    @media (max-width: 1270px) {
      transform: translateX(-92px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1145px) {
      transform: translateX(-80px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1003px) {
      transform: translateX(0px) translateZ(-50px) translateY(-90px);
    }
  }
`;

export const StyledRadioInput3 = styled.input`
  &:checked ~ .dots label[for='t-2'] {
    transform: scale(1.5);
    background-color: #d9d9d9;
  }
  &:checked ~ .dots label[for='t-3'] {
    transform: scale(2);
  }
  &:checked ~ .dots label[for='t-4'] {
    transform: scale(1.5);
    background-color: #d9d9d9;
  }
  &:checked ~ .testimonials label[for='t-2'] {
    transform: translateX(-127px) translateZ(-35px) translateY(15px);

    @media (max-width: 1400px) {
      transform: translateX(-92px) translateZ(-35px) translateY(8px);
    }
    @media (max-width: 1270px) {
      transform: translateX(-92px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1145px) {
      transform: translateX(-80px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1003px) {
      transform: translateX(0px) translateZ(-50px) translateY(-90px);
    }
  }
  &:checked ~ .testimonials label[for='t-3'] {
    z-index: 3;
  }
  &:checked ~ .testimonials label[for='t-4'] {
    transform: translateX(175px) translateZ(-35px) translateY(15px);
    z-index: 2;
    @media (max-width: 1400px) {
      transform: translateX(120px) translateZ(-35px) translateY(8px);
    }
    @media (max-width: 1270px) {
      transform: translateX(120px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1145px) {
      transform: translateX(100px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1003px) {
      transform: translateX(0px) translateZ(-50px) translateY(90px);
    }
  }
`;

export const StyledRadioInput4 = styled.input`
  &:checked ~ .dots label[for='t-2'] {
    transform: scale(1.5);
    background-color: #d9d9d9;
  }
  &:checked ~ .dots label[for='t-3'] {
    transform: scale(1.5);
    background-color: #d9d9d9;
  }
  &:checked ~ .dots label[for='t-4'] {
    transform: scale(2);
  }
  &:checked ~ .testimonials label[for='t-2'] {
    transform: translateX(175px) translateZ(-35px) translateY(15px);

    @media (max-width: 1400px) {
      transform: translateX(138px) translateZ(-35px) translateY(15px);
    }
    @media (max-width: 1270px) {
      transform: translateX(138px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1145px) {
      transform: translateX(100px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1003px) {
      transform: translateX(0px) translateZ(-50px) translateY(90px);
    }
  }
  &:checked ~ .testimonials label[for='t-3'] {
    transform: translateX(-127px) translateZ(-35px) translateY(15px);
    z-index: 2;
    @media (max-width: 1400px) {
      transform: translateX(-92px) translateZ(-35px) translateY(15px);
    }
    @media (max-width: 1270px) {
      transform: translateX(-92px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1145px) {
      transform: translateX(-80px) translateZ(-35px) translateY(5px);
    }
    @media (max-width: 1003px) {
      transform: translateX(0px) translateZ(-50px) translateY(-90px);
    }
  }
  &:checked ~ .testimonials label[for='t-4'] {
    z-index: 3;
  }
`;
